// src/components/ActionComponent.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import RenderComponent from '../../../component/Component';
import { useNavigate } from 'react-router-dom';
import { confirmDelete, confirmModal } from '../../../helpers/PromptUtils';
import { getToken } from '../../../helpers/Jwt';

const ActionComponent = ({ action, callChange, triggerData, custom = false, defaultValue}) => {
    const [entities, setEntities] = useState([]);
    const [items, setItems] = useState([]);

    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    
    const arrayToObject = (array) => {
        return array.reduce((accumulator, current) => {
            if (current.key && current.value !== undefined) {
                accumulator[current.key] = current.value;
            }
            return accumulator;
        }, {});
    };

    const convertObjectToArray = (obj) => {
        return Object.entries(obj).map(([key, value]) => ({ key, value }));
    };

    const renderItem = (item) => {
        const itemsArray = convertObjectToArray(item);
        if (itemsArray.length === 0) {
            return <p>No items to display</p>;
        }

        const excludedKeys = new Set(['created_at', 'updated_at', 'updated_by']);

        const filteredItems = itemsArray.filter(item => !excludedKeys.has(item.key));

        return (
            <div className="card-grid">
                {filteredItems.map((item, index) => {
                    if (item.key === 'id' || item.key === 'id_product') {
                        return null;
                    }
                    return (
                        <div key={`${item.key}_${index}`} className='d-flex text-left'>
                            <p>{item.key}</p>
                            <p><strong>{item.value}</strong></p>
                        </div>
                    )
                })}
            </div>
        );
    };

    const fetchData = async (catchResponse) => {
        try {
            if (action.action_request_onload?.integration == "Y") {
                const response = await axios({
                    method: 'GET',
                    url: action.action_request_onload.url,
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        "Content-Type": "application/json"
                    }
                });
                
                const data = response?.data || [];
                setEntities(data);
            } else {
                const response = await axios({
                    method: 'GET',
                    url: `${process.env.REACT_APP_API_BASE_URL}api/dashboard/request?url=${action.action_request_onload.url}`,
                    headers: {
                        Authorization: `Bearer ${getToken()}`,
                        "Content-Type": "application/json"
                    }
                });
                
                const data = response?.data?.result || [];
                setEntities(data);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            const confirmed = confirmDelete('Are you sure you want to delete this component?');
            if (confirmed) {
                axios({
                    method: 'POST',
                    url: process.env.REACT_APP_API_BASE_URL + 'api/dashboard/component/delete',
                    data: {
                        id: id
                    }
                }).then(function (response) {
                    window.location.reload();
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {

        setEntities([]);
        setItems([]);
        setLoading(true);

        if (action.element === 'grid' && action?.action_request_onload?.method === 'GET') {
            fetchData(action?.action_response || []);
        } else if (action.element === 'table' && action?.action_request_onload?.method === 'GET') {
            fetchData(action?.action_response || []);
        } else if (action.element === 'list' && action?.action_request_onload?.method === 'GET') {
            fetchData(action?.action_response || []);
        }
        else if (action.element === 'input' && action?.action_request_onload?.method === 'GET'
            && (action?.action_attribute?.find(attr => attr.key === 'type').value == 'select' || 
                action?.action_attribute?.find(attr => attr.key === 'type').value == 'select_id')
        ) {
            fetchData(action?.action_response || []);
        }
        else {
            setLoading(false);
        }
    }, [action]);

    useEffect(() => {
        const itemsArray = entities.map(item => renderItem(item));
        setItems(itemsArray);
    }, [entities]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (action.element === 'form') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`,
                    id_module: action.id_module,
                    component_id: action.id,
                    component_request_onload: action.action_request_onload,
                    component_request: action.action_request_ontrigger
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}                                
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
            />
        );
    }

    if (action.element === 'button') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
                callRequest={async (data) => {
                    const confirmed = confirmModal(`Yakin ${action.action_request.description}?`);
                    if (confirmed) {
                        try {
                            await axios({
                                method: action.action_request.method,
                                url: `${process.env.REACT_APP_API_BASE_URL}api/dashboard/request`,
                                data : {
                                    id: triggerData.id.value,
                                    url: action.action_request.url
                                }
                            });                        
                        } catch (error) {
                            alert(error);
                        } finally {
                            window.location.reload();
                        }                        
                    }
                }}
            />
        );
    }

    if (action.element === 'buttontable') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
                callRequest={async (data) => {
                    const confirmed = confirmModal(`Yakin ${action?.action_request_ontrigger?.description}?`);
                    if (confirmed) {
                        try {
                            if (action?.action_request_ontrigger?.integration == "Y") {
                                await axios({
                                    method: action.action_request_ontrigger.method,
                                    url: action.action_request_ontrigger.url,
                                    data : {
                                        id: triggerData.id.value
                                    },
                                    headers: {
                                        Authorization: `Bearer ${getToken()}`,
                                        "Content-Type": "application/json"
                                    }
                                });                                 
                            } else {
                                await axios({
                                    method: action.action_request_ontrigger.method,
                                    url: `${process.env.REACT_APP_API_BASE_URL}api/dashboard/request`,
                                    data : {
                                        id: triggerData.id.value,
                                        url: action.action_request_ontrigger.url
                                    },
                                    headers: {
                                        Authorization: `Bearer ${getToken()}`,
                                        "Content-Type": "application/json"
                                    }
                                });                        
                            }
                        } catch (error) {
                            alert(error);
                        } finally {
                            window.location.reload();
                        }                        
                    }
                }}
            />
        );
    }

    if (action.element === 'link') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                callRequest={async (data) => {   
                }}
            />
        );
    }

    if (action.element === 'linktable') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                callRequest={async (data) => {   
                    const attribute = arrayToObject(action.action_attribute);
                    // navigate(`${attribute.to}/${triggerData.id.value}`);
                    window.open(`${attribute.to}/${triggerData.id.value}`, '_blank');
                }}
            />
        );
    }

    if (action.element === 'input') {
        return (                    
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`, items: entities
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
                callChange={callChange}
                defaultValue={defaultValue}
            />
        );
    }

    if (action.element === 'grid') {
        return <RenderComponent
            enableCustom={custom}
            type={action.element}
            component={{ title: `${action.element} (Component ${action.id})`, items }}
            attribute={arrayToObject(action.action_attribute)}
            actionRemove={(data) => {
                handleDelete(action.id);
            }}
            actionEdit={(data) => {
                navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
            }}
            actionRequest={(data) => {
                if (action.action_request_ontrigger?.id) {
                    navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                } else {
                    navigate(`/activity-request/ONTRIGGER/${action.id}`);
                }
            }}
            actionRequestOnLoad={(data) => {
                if (action.action_request_onload?.id) {
                    navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                } else {
                    navigate(`/activity-request/ONLOAD/${action.id}`);
                }
            }}
        />;
    }

    if (action.element === 'list') {
        return <RenderComponent
            enableCustom={custom}
            type={action.element}
            component={{ title: `${action.element} (Component ${action.id})`, items }}
            attribute={arrayToObject(action.action_attribute)}
            actionRemove={(data) => {
                handleDelete(action.id);
            }}
            actionEdit={(data) => {
                navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
            }}
            actionRequest={(data) => {
                if (action.action_request_ontrigger?.id) {
                    navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                } else {
                    navigate(`/activity-request/ONTRIGGER/${action.id}`);
                }
            }}
            actionRequestOnLoad={(data) => {
                if (action.action_request_onload?.id) {
                    navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                } else {
                    navigate(`/activity-request/ONLOAD/${action.id}`);
                }
            }}
        />;
    }

    if (action.element === 'table') {
        const keys = entities.length > 0 ? Object.keys(entities[0]) : [];

        const columns = keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        }));
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`,
                    id_module: action.id_module,
                    component_id: action.id,
                    items: entities,
                    columns: columns
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
                callChange={() => {
                    window.location.reload();
                }}
            />
        );
    }

    if (action.element === 'text') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {                    
                }}
                callRequest={async (data) => {                    
                }}
            />
        );
    }

    if (action.element === 'qrcode') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
                callRequest={async (data) => {                    
                }}
            />
        );
    }

    if (action.element === 'image') {
        return (
            <RenderComponent
                enableCustom={custom}
                type={action.element}
                component={{
                    title: `${action.element} (Component ${action.id})`
                }}
                attribute={arrayToObject(action.action_attribute)}
                actionRemove={(data) => {
                    handleDelete(action.id);
                }}
                actionEdit={(data) => {
                    navigate(`/edit-activity-component/${action.id_module}/${action.id_parent}/${action.id}`);
                }}
                actionRequest={(data) => {
                    if (action.action_request_ontrigger?.id) {
                        navigate(`/edit-activity-request/ONTRIGGER/${action.id}/${action.action_request_ontrigger.id}`);
                    } else {
                        navigate(`/activity-request/ONTRIGGER/${action.id}`);
                    }
                }}
                actionRequestOnLoad={(data) => {
                    if (action.action_request_onload?.id) {
                        navigate(`/edit-activity-request/ONLOAD/${action.id}/${action.action_request_onload.id}`);
                    } else {
                        navigate(`/activity-request/ONLOAD/${action.id}`);
                    }
                }}
                callRequest={async (data) => {                    
                }}
            />
        );
    }

    return <div>Unknown element type : {action.element}</div>;
};

export default ActionComponent;
